import { FC, useLayoutEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import { socket } from '../modules/socket';
import { useNavigationData } from '../modules/NavigationProvider';
import { useDataContext } from '../modules/data/DataContext';
import Battery from '../components/Battery';
import IconSVG from '../components/IconSVG';

const EnergyPage: FC = () => {
  const { t } = useTranslation('energy');
  const { lastData } = useDataContext();
  const { setPath, setButtonText, setHeaderText } = useNavigationData();

  useLayoutEffect(() => {
    setPath('/menu');
    setButtonText();
    setHeaderText(t('title'));

    const interval = setInterval(() => {
      if (!socket || !socket.connected) return;
      // Send Mqtt
      console.debug('Sending mqtt request');
      socket.emit('data/req', 'mppt,temp');
    }, 10000); // 10 segundos

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const level = useMemo(
    () =>
      // map level 22v-28.5v to 0-100
      lastData?.mppt?.v ? Math.round((lastData.mppt.v / 28.5) * 100) : 0,
    [lastData?.mppt?.v]
  );

  return (
    <div className="pole-bg position-relative d-flex justify-content-center align-items-center">
      <Battery level={level} />
      <div
        className="pole-energy"
        style={
          lastData?.mppt?.ppv && lastData.mppt.ppv > 0
            ? {}
            : { background: '#008266' }
        }
      />
      <Row xs={2} className="justify-content-between h-100 mt-5 text-center">
        <Col className="d-flex flex-column justify-content-center align-items-center gap-2">
          <IconSVG name="production-time" />
          <div>
            <p className="text-uppercase m-0">{t('lifetime')}</p>
            <p>{lastData?.lifetime?.toFixed(2) ?? 0} kWh</p>
          </div>
        </Col>
        <Col className="d-flex flex-column justify-content-center align-items-center gap-2">
          <IconSVG name="production-settings" />
          <div>
            <p className="text-uppercase m-0">{t('production')}</p>
            <p>{`${lastData?.mppt ? lastData.mppt.ppv : 0} W`}</p>
          </div>
        </Col>
        <Col className="d-flex flex-column justify-content-center align-items-center gap-2">
          <IconSVG name="temperature" />
          <div>
            <p className="text-uppercase m-0">{t('temperature')}</p>
            <p>{`${lastData?.temp?.temperature ?? 0}ºC`}</p>
          </div>
        </Col>
        <Col className="d-flex flex-column justify-content-center align-items-center gap-2">
          <IconSVG name="consumption" />
          <div>
            <p className="text-uppercase m-0">{t('consumption')}</p>
            <p>{`${
              lastData?.mppt
                ? (
                    (lastData.mppt.il / 1000) *
                    (lastData.mppt.v / 1000)
                  ).toFixed(2)
                : 0
            } W`}</p>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default EnergyPage;
